/**
 * SourceBadge — small chip that sits inside a component row showing where
 * the data originated. Iter220 — extracted from `AppraisalComponentsTab.js`
 * for shared use by the Repairs builders (Iter221+).
 *
 * Reads from `line.import_source` (component_lines schema) AND `line.source`
 * (appraisal_components schema) so it works in both push pipelines.
 *
 * Recognised values:
 *   - 'roof_diagram' / 'diagram' → blue "from Diagram"
 *   - 'edited'                   → amber "Edited"
 *   - 'drive_by_quick'           → purple "Drive-by"
 *   - anything else / missing    → no badge (fresh manual entry)
 */
import React from 'react';

const PALETTE = {
  diagram:        { bg: 'bg-sky-100',    text: 'text-sky-800',    ring: 'ring-sky-200',    label: 'from Diagram', symbol: '📐' },
  roof_diagram:   { bg: 'bg-sky-100',    text: 'text-sky-800',    ring: 'ring-sky-200',    label: 'from Diagram', symbol: '📐' },
  edited:         { bg: 'bg-amber-100',  text: 'text-amber-800',  ring: 'ring-amber-200',  label: 'Edited',       symbol: '✎'  },
  drive_by_quick: { bg: 'bg-purple-100', text: 'text-purple-800', ring: 'ring-purple-200', label: 'Drive-by',     symbol: '🚗' },
};

export default function SourceBadge({ line }) {
  const src = (line.import_source || line.source || '').toLowerCase();
  if (!src || src === 'manual') return null;
  const p = PALETTE[src] || { bg: 'bg-slate-100', text: 'text-slate-700', ring: 'ring-slate-200', label: src, symbol: '•' };
  return (
    <span
      data-testid={`comp-line-source-${src}`}
      className={`absolute right-2 top-2 inline-flex items-center gap-1 ${p.bg} ${p.text} ring-1 ${p.ring} px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider`}
      title={`This line was created via ${p.label}.`}
    >
      <span aria-hidden>{p.symbol}</span> {p.label}
    </span>
  );
}
